import store from "@/store";
import {isEqual, uniqWith} from "lodash";
import notifyHelper from "@/helpers/notifyHelper";

export function imageToBase64(url) {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + store.getters["auth/accessToken"]);
    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };
    return new Promise(resolve => {
        fetch(url, requestOptions)
            .then(response => response.blob())
            .then(blob => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = error => console.log({error})
                reader.readAsDataURL(blob)
            });
    });
}

export function convertAccentedLettersToUnsigned(str) {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D");
}

export function $args(func) {
    return (func + "")
        .replace(/[/][/].*$/mg, "") // strip single-line comments
        .replace(/\s+/g, "") // strip white space
        .replace(/[/][*][^/*]*[*][/]/g, "") // strip multi-line comments
        .split("){", 1)[0].replace(/^[^(]*[(]/, "") // extract the parameters
        .replace(/=[^,]+/g, "") // strip any ES6 defaults
        .split(",").filter(Boolean); // split & filter [""]
}

export const randomStr = () => (Math.random() + 1).toString(36).substring(6);

export const $wait = ms => new Promise(resolve => {
    setTimeout(resolve, ms);
});

let timeoutDebounce = null;

export function $debounce(ms = 500, immediate = false) {
    return new Promise(resolve => {
        const later = () => {
            timeoutDebounce = null;
            if (!immediate) {
                resolve();
            }
        };
        const callNow = immediate && !timeoutDebounce;
        clearTimeout(timeoutDebounce);
        timeoutDebounce = setTimeout(later, ms);

        if (callNow) {
            resolve();
        }
    });
}

export function downloadFile(url, fileName) {
    const a = document.createElement("a")
    a.href = url;
    a.target = "_blank";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export const formatBytes = (bytes, decimals) => {
    if (bytes === 0) {
        return "0 Byte";
    }
    const k = 1024; //Or 1 kilo = 1000
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
};

export const getFileExtension = name => name.slice((name.lastIndexOf(".") - 1 >>> 0) + 2)

export function getEmbedYoutube(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const youtubeUrl = "https://www.youtube.com/embed/";
    if (match && match[2].length === 11) {
        return youtubeUrl + match[2];
    } else {
        return false;
    }
}

export function redirectNewTab(link = "#") {
    const a = document.createElement("a")
    a.href = link;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function download2(url, fileName) {
    const a = document.createElement("a")
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function download(url, fileName){
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function(){
        if (xhr.status === 200){
            const urlCreator = window.URL || window.webkitURL;
            const imageUrl = urlCreator.createObjectURL(this.response);
            const tag = document.createElement("a");
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
            notifyHelper.success("Download successfully");
        }
        else {
            notifyHelper.error("Download failed");
        }
    }

    xhr.onerror = function () {

        notifyHelper.error("Can't download file - server error");
    };

    xhr.ontimeout = function () {
        notifyHelper.error("Download timeout");
    };

    xhr.send();
}

export function unique(arr) {
    return uniqWith(arr, isEqual)
}

export function getIds(list = []) {
    let ids = [];
    if (!list.length) return ids;
    if (list.length === 1) {
        ids = [list[0].id];
    } else {
        ids = list.map(x => x.id);
    }
    return ids;
}

export function generatePassword() {
    const length = 8; // Độ dài mật khẩu
    const charset =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset[randomIndex];
    }
    return password;
}

export function getLang() {
    const defLocale = "vi";

    try {
        const query = new URLSearchParams(window.location.search);
        let locale = query.get("lang");
        if (locale) {
            locale = locale.substring(0, 2);
            if (["en", "vi"].includes(locale)) {
                window.localStorage.setItem("LOCALE", locale);
                return locale;
            }
        }

        locale = window.localStorage.getItem("LOCALE");
        if (locale && locale.length > 2)
            locale = locale.substring(0, 2);

        return locale || defLocale;

    } catch (e) {
        console.log(e);
    }

    return defLocale;
}
